/// <amd-module name="DistributedTaskUI/Resources/ResourcesActionsCreator" />
import { CheckIssueData, ResourceCheckIssue } from "Checks/Client/Contracts/PipelinesChecks";
import { ResourceFilters, ResourcesHubData } from "DistributedTask/Client/Contracts/TaskAgent";
import { FeatureFlagConstants, ResourceTypeNames } from "Generated/Constants";
import { ResourcesActionsHub } from "ResourcesActionsHub";
import { ResourcesHubDataExtended } from "ResourcesHub.Model";
import { ResourcesSource } from "ResourcesSource";
import { Action } from "VSS/Reflux/Action";

export class ResourcesActionsCreator {
    constructor(actions: ResourcesActionsHub, source: ResourcesSource) {
        this._actions = actions;
        this._source = source;
    }

    public static getKey(): string {
        return "service-endpoints-section-actionscreator";
    }

    public initializeList(ignoreCache: boolean) {
        this._source.initialize(ignoreCache).then((resourceHubData: ResourcesHubData) => {
            this.updateIssuesForResources(resourceHubData, this._actions.initializeResources);
        });
    }

    public filterOptions(filters: ResourceFilters) {
        this._source.getResources(filters).then((data: ResourcesHubData) => {
            this.updateIssuesForResources(data, this._actions.applyFilters);
        });
    }

    public loadMoreData(filters: ResourceFilters, continuationToken: string) {
        this._source.getResources(filters, continuationToken).then((data: ResourcesHubData) => {
            this.updateIssuesForResources(data, this._actions.fetchNextPage);
        });
    }

    private updateIssuesForResources(resourceHubData: ResourcesHubData, action: Action<ResourcesHubData>) {
        const _showCheckIssues = this._source.getResourcesFeatureFlag(FeatureFlagConstants.EnableChecksScalabilityResourceIssues);
        if (_showCheckIssues && resourceHubData && resourceHubData.resourceItems && resourceHubData.resourceItems.length > 0) {
            let resourceParams: { [key: string]: string; } = {
                "resourceTypeName": ResourceTypeNames.ServiceEndpoint,
                "resourceIds": resourceHubData.resourceItems.map(r => r.id).join(",")
            };
            this._source.getResourcesCheckIssues(resourceParams)
                .then((checkIssueDataResult: CheckIssueData) => {
                    let resourcesWithIssuesResult: ResourceCheckIssue[] = checkIssueDataResult && checkIssueDataResult.resourcesWithCheckIssuesList;
                    let resourceCombinedHubData: ResourcesHubDataExtended = resourcesWithIssuesResult && resourcesWithIssuesResult.length > 0
                        ? { ...resourceHubData, resourceIssues: resourcesWithIssuesResult } : resourceHubData;
                    action.invoke(resourceCombinedHubData);
                });
        } else {
            action.invoke(resourceHubData);
        }
    }

    private _actions: ResourcesActionsHub;
    private _source: ResourcesSource;
}
